<template>
  <nav v-if="!shouldHide" id="nav" class="navbar navbar-expand navbar-dark fixed-top bg-primary py-1">
    <router-link class="navbar-brand" to="/" v-if="!isLoadingAppInfo">
      <img class="mr-1" :src="logoSrc" alt="Logo" width="28px"/> {{ appName }}
    </router-link>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExample04"
            aria-controls="navbarsExample04" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarsExample04">
      <ul class="navbar-nav mr-auto align-items-center">
        <template v-if="userCheck()">
          <!--<li class="nav-item">
            <router-link id="btnUpgrade" class="nav-link mr-3" to="/pricing-plans">
              <b-icon icon="gift-fill" class="mr-1"/>
              Nâng cấp ngay
            </router-link>
          </li>-->
          <li class="nav-item" v-if="isUserAdmin() || isManager() || isCustomer()">
            <router-link class="nav-link" to="/dashboard">Dashboard</router-link>
          </li>
          <li class="nav-item" v-if="isUserAdmin()">
            <b-dropdown variant="link" toggle-class="nav-link text-decoration-none" menu-class="shadow"
                        :class="{ active: $route.path.startsWith('/admin-accounts') || $route.path.startsWith('/sale-accounts') || $route.path.startsWith('/customer-admin-accounts') || $route.path.startsWith('/app-names') }">
              <template v-slot:button-content>{{ $t("headerMenuAdmin") }}</template>
              <b-dropdown-item active-class="font-weight-bold" to="/admin-accounts">{{ $t("serviceAdminAccount") }}</b-dropdown-item>
              <b-dropdown-item active-class="font-weight-bold" to="/sale-accounts">{{ $t("saleAccount") }}</b-dropdown-item>
              <b-dropdown-item active-class="font-weight-bold" to="/customer-admin-accounts">{{ $t("customerAdminAccount") }}</b-dropdown-item>
              <b-dropdown-item active-class="font-weight-bold" to="/app-names">{{ $t("application") }}</b-dropdown-item>
            </b-dropdown>
          </li>
          <li v-if="isManager()" class="nav-item">
            <router-link class="nav-link" to="/customer-admin-accounts">{{ $t("customerAdminAccount") }}</router-link>
          </li>
          <template v-if="isUserAdmin() || isManager()">
            <li class="nav-item">
              <router-link class="nav-link" to="/subscription-plans">{{ $t("subscriptionPlan") }}</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/customers">{{ $t("customer") }}</router-link>
            </li>
          </template>
          <li class="nav-item" v-if="shouldShowMeetingsMenu">
            <router-link class="nav-link" to="/meetings">{{ $t("meeting") }}</router-link>
          </li>
          <li class="nav-item" v-if="isCustomer() || isCustomerUser()">
            <router-link class="nav-link" to="/contacts">{{ $t("contact") }}</router-link>
          </li>
          <li class="nav-item" v-if="isCustomer()">
            <router-link class="nav-link" to="/customer-user-accounts">{{ $t("manageAccount") }}</router-link>
          </li>
          <!-- <li class="nav-item" v-if="isCustomer()">
            <router-link class="nav-link" to="/email-templates">{{ $t("emailTemplate") }}</router-link>
          </li> -->
          <li class="nav-item" v-if="shouldShowCalendarMenu()">
            <b-dropdown variant="link" toggle-class="nav-link text-decoration-none" menu-class="shadow"
                        :class="{ active: $route.path.startsWith('/calendar') || $route.path.startsWith('/locations') }">
              <template v-slot:button-content>{{ $t("weeklyCalendar") }}</template>
              <b-dropdown-item active-class="font-weight-bold" to="/calendar">{{ $t("weeklyCalendarList") }}</b-dropdown-item>
              <b-dropdown-item active-class="font-weight-bold" to="/locations">{{ $t("meetingLocation") }}</b-dropdown-item>
            </b-dropdown>
          </li>
          <li class="nav-item" v-if="isUserAdmin() || isManager() || isCustomer()">
            <b-dropdown variant="link" toggle-class="nav-link text-decoration-none" menu-class="shadow"
                        :class="{ active: $route.path.startsWith('/reports') }">
              <template v-slot:button-content>{{ $t("report") }}</template>
              <b-dropdown-item active-class="font-weight-bold" to="/reports/meeting-count" v-if="isUserAdmin() || isManager()">{{ $t("meetingCount") }}</b-dropdown-item>
              <b-dropdown-item active-class="font-weight-bold" to="/reports/meeting-count-d" v-if="isUserAdmin() || isManager()">{{ $t("meetingCountDetails") }}</b-dropdown-item>
              <b-dropdown-item active-class="font-weight-bold" to="/reports/meeting-count-total" v-if="isUserAdmin() || isManager()">{{ $t("meetingCountTotal") }}</b-dropdown-item>
              <b-dropdown-item active-class="font-weight-bold" to="/reports/meeting-detail-report" v-if="isCustomer()">{{ $t("meetingDetailReport") }}</b-dropdown-item>
            </b-dropdown>
          </li>
          <li class="nav-item" v-if="isUserSuperAdmin()">
            <b-dropdown variant="link" toggle-class="nav-link text-decoration-none" menu-class="shadow"
                        :class="{ active: $route.path.startsWith('/admin-settings') || $route.path.startsWith('/system-logs') }">
              <template v-slot:button-content>{{ $t("settings") }}</template>
              <b-dropdown-item active-class="font-weight-bold" to="/admin-settings/password-policy">{{ $t("passwordPolicy") }}</b-dropdown-item>
              <!-- <b-dropdown-item active-class="font-weight-bold" to="/admin-settings/ip-policy">{{ $t("ipBlacklist") }}</b-dropdown-item> -->
              <!-- <b-dropdown-item active-class="font-weight-bold" to="/system-logs">{{ $t("systemLogs") }}</b-dropdown-item> -->
              <!-- <b-dropdown-item active-class="font-weight-bold" to="/admin-settings/backup-policy">{{ $t("backup1") }}</b-dropdown-item> -->
              <!-- <b-dropdown-item active-class="font-weight-bold" to="/admin-settings/port-policy">{{ $t("changeWebPort") }}</b-dropdown-item> -->
              <b-dropdown-item active-class="font-weight-bold" to="/admin-settings/manage-config">{{ $t("manageConfigulation") }}</b-dropdown-item>
            </b-dropdown>
          </li>
          <!-- Ẩn tính năng/ upcode prod -->
          <!-- <li class="nav-item" v-if="isCustomer()">
            <router-link class="nav-link" to="/guideapi">Hướng dẫn sử dụng</router-link>
          </li> -->
        </template>
      </ul>
      <ul class="navbar-nav align-items-center">
        <template v-if="user">
          <li v-if="sessionExpCountdownStr" class="nav-item">
            <span class="nav-link" title="Thời gian còn lại của phiên đăng nhập" v-b-tooltip>
              <b-icon icon="clock" class="mr-1"></b-icon>
              {{ sessionExpCountdownStr }}
            </span>
          </li>
          <li class="nav-item">
            <b-dropdown variant="link" toggle-class="nav-link text-decoration-none" menu-class="shadow"
                        :class="{ active: $route.path.startsWith('/account') }">
              <template v-slot:button-content>
                <b-icon icon="person" class="mr-1"></b-icon>
                {{ user.name }}
              </template>
              <template v-if="userCheck()">
                <b-dropdown-item to="/account">{{ $t("manageAccount") }}</b-dropdown-item>
                <b-dropdown-divider/>
              </template>
              <b-dropdown-item-button @click="onClickLogout">{{ $t("logout") }}</b-dropdown-item-button>
            </b-dropdown>
          </li>
        </template>
        <li class="nav-item" v-else>
          <router-link class="nav-link" to="/login"><i class="fas fa-key mr-2"></i>{{ $t("login") }}</router-link>
        </li>
        <div class="locale-changer ml-3" v-if="shouldShowI18nMenu">
          <b-dropdown variant="link" toggle-class="p-0 text-white text-decoration-none" no-caret>
            <template v-slot:button-content>
              <img class="emoji" :src="displayLangImg">
            </template>
            <b-dropdown-item @click="onClickLanguage('vi')">
              <img class="emoji" src="icon/flag-vn.png" alt="🇻🇳"> Tiếng Việt
            </b-dropdown-item>
            <b-dropdown-item @click="onClickLanguage('en')">
              <img class="emoji" src="icon/flag-en.png" alt="🇬🇧"> English
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </ul>
      <!--<div class="navbar-nav d-flex flex-row align-items-center nav-link">
        <img class="img-fluid img-circle mr-2" alt="profile pic" src="https://picsum.photos/200" width="36px">
        Quản trị hệ thống
      </div>-->
    </div>
  </nav>
</template>


<style lang="scss" scoped>
  #btnUpgrade {
    color: #ffe148;
  }
</style>


<script lang="ts">
  import {Component, Vue} from 'vue-property-decorator';
  import _ from "lodash";
  import environment from "@/environment";
  import * as userService from "@/service/userService";
  import * as appNamesService from "@/service/appNamesService";
  import BaseComponent from "@/components/BaseComponent";

  @Component
  export default class Header extends BaseComponent {

    isLoadingAppInfo = true;
    appName = "";
    logoSrc = "";

    sessionExpCountdownStr = "";
    sessionCountdownIntervalHandler = null;

    shouldHide = false;
    shouldShowI18nMenu = !!window["vnptEConferencePortalEnableI18nMenu"] || false;
    // shouldShowI18nMenu  = true;
    get displayLangImg() {
      return {
        vi: "icon/flag-vn.png",
        en: "icon/flag-en.png"
      }[this.$i18n.locale];
    }

    mounted() {
      // this.shouldHide = !!this.$route.meta?.hideHeaderAndFooter;
      // console.log(`Header shouldHide`, this.shouldHide);
      //
      // this.$router.afterEach((to, from) => {
      //   this.shouldHide = !!to.meta?.hideHeaderAndFooter;
      //   console.log(`Header shouldHide`, this.shouldHide);
      // });

      this.getAppInfo();
    }


    async getAppInfo() {
      try {
        this.isLoadingAppInfo = true;
        const appInfo = await appNamesService.getCurrent();
        this.appName = appInfo.name;
        this.logoSrc = appInfo.logo;

      } catch (e) {
        console.error(e);

      } finally {
        document.title = this.appName = this.appName || "VNPT GoMeet Portal";
        this.logoSrc = this.logoSrc || "images/logoVNPT.png";
        this.isLoadingAppInfo = false;
      }
    }


    setupSessionCountdown() {
      this.sessionCountdownIntervalHandler = setInterval(() => {
        const expTime = userService.getTokenExpTime();
        if (expTime) {
          const duration = expTime - new Date().getTime() / 1000;
          const hours = Math.floor(duration / 3600);
          const mins = Math.floor((duration % 3600) / 60).toString().padStart(2, "0");
          this.sessionExpCountdownStr = `${hours}h ${mins}m`;

        } else {
          this.sessionExpCountdownStr = "";
        }
      }, 1000);
    }

    shouldShowCalendarMenu(): boolean {
      return window["vnptEConferencePortalShowCalendarMenu"] && (this.isCustomer() || this.isCustomerUser());
    }

    get shouldShowMeetingsMenu(): boolean {
      return ["Admin", "SupperAdmin", "Manager", "Customer", "User", "View"].includes(this.user?.role);
    }

    onClickLogout() {
      userService.signOut();
    }

    onClickLanguage(locale) {
      localStorage.setItem("vue-i18n-locale", locale);
      location.reload();
    }

    destroyed() {
      clearInterval(this.sessionCountdownIntervalHandler);
    }

  }
</script>
